import React from "react";
import { AiFillFilePdf } from "react-icons/ai";
import PageWrapper from "../../../components/PageWrapper/PageWrapper";
import HeroSection from "../../../components/HeroSection/HeroSection";
import HeroCaption from "../../../components/HeroCaption/HeroCaption";
import CustomIcon from "../../../components/CustomIcon/CustomIcon";

import FacultyResponsive from "../../../components/FacultyResponsive/FacultyResponsive";
import CoursesResponsive from "../../../components/CoursesResponsive/CoursesResponsive";
import DepartmentInfoResponsive from "../../../components/DepartmentInfoResponsive/DepartmentInfoResponsive";
import DepartmentAboutInfoResponsive from "../../../components/DepartmentAboutInfoResponsive/DepartmentAboutInfoResponsive";
import HODResponsive from "../../../components/HODResponsive/HODResponsive";
import ResourcesResponsive from "../../../components/ResourcesResponsive/ResourcesResponsive";
import { electricalMaterials } from "../../../static-data/coursematerial.data";
import { electricalLessonPlan } from "../../../static-data/courselessonplan.data";

// import { electrical } from "../../static-data/coursemater.data";

const hodData = {
  imageUrl: require("../../../assets/hod-images/ee.png"),
  designation: "Head of the Department",
  name: "Prof. Deepak Kumar Sahoo",
  feedback: `Welcome to the Department of Electrical Engineering, Electrical and Electronics Engineering.
As the Head of the Department, it is my immense pleasure to extend a warm welcome to all our students, faculty, and visitors. Our department stands at the forefront of innovation, offering an enriching academic excellence that blends theoretical knowledge with hands-on skill-oriented application. We are dedicated to fostering an environment where curiosity, research, and creativity thrive.
In today’s fast-paced world, electrical and electronics engineering plays a vital role in shaping technological advancements. we are committed to equipping our students with the knowledge and skills required to excel in this dynamic field. I  am confident that together, as a vibrant academic community, we will continue to achieve excellence and contribute significantly to the growth of technology and society.
    `,
};

const eeSyllabus =
  "https://drive.google.com/drive/folders/1qPIJ1VwWL8ttsjeuEml9QrA-4W3Hg-i3?usp=drive_link";

const ElectricalAndElectronicsPage = () => {
  return (
    <PageWrapper className="mt-n6">
      <HeroSection className="bg-page-background-7">
        <HeroCaption
          title="Electrical & Electronics Department"
          position="bottom-left"
          breadcrumb={true}
          breadcrumbPrefix="Home"
        />
      </HeroSection>
      <DepartmentInfoResponsive
        title={"Electrical & ElectronicsEngineering (EE & EEE)"}
        desc={`The Electrical and Electronics Engineering (EE & EEE) Department at NIET is dedicated to providing a comprehensive education in the field of electrical and electronics engineering. Our department offers a range of programs and courses designed to equip students with the skills and knowledge they need to succeed in the industry.

`}
      />
      <HODResponsive hodData={hodData} />
      <DepartmentAboutInfoResponsive
        title={"About department"}
        desc={`The Electrical and Electronics Engineering (EEE) Department at NIET is dedicated to providing a comprehensive education in the field of electrical and electronics engineering. Our department offers a range of programs and courses designed to equip students with the skills and knowledge they need to succeed in the industry.
				Our faculty members are experts in their respective fields and have extensive experience in both academia and industry. They are committed to providing students with a challenging and rigorous curriculum that prepares them for successful careers in the field of electrical and electronics engineering.
				Our EEE Department offers a B.Tech in Electrical Engineering program that covers a wide range of topics including electrical circuits, power systems, electrical machines, control systems, instrumentation, and electrical and electronics design. We also offer elective courses in emerging areas such as renewable energy, power electronics, and artificial intelligence, allowing students to specialize in their area of interest.
				Our department is equipped with state-of-the-art facilities, including electrical and electronics labs, simulation tools, and equipment, to support students' practical learning experience. Our faculty members work closely with students to provide hands-on training and real-world experience, preparing them for successful careers in the industry
				We also encourage students to participate in co-curricular activities such as robotics competitions, technical paper presentations, and project exhibitions, providing them with opportunities to showcase their skills and talents, and network with industry professionals.
				
                
`}
        href={
          process.env.PUBLIC_URL +
          "/DEPARTMENT OF ELECTRICAL ENGINEERING WORD DATA-1.docx"
        }
        docLinkText={"EE & EEE Department Information"}
      />

      <ResourcesResponsive
        syllabusLink={eeSyllabus}
        courseMaterial={electricalMaterials}
        courseLessonPlan={electricalLessonPlan}
      />
    </PageWrapper>
  );
};

export default ElectricalAndElectronicsPage;
